import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { AddTagFormData } from '../types';

export function BlockSampleDetailsSection() {
  const { control } = useFormContext<AddTagFormData>();

  return (
    <>
      <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-6">
        <div className="space-y-4">
          <ControlledFormInput
            name="sampleSize"
            label="Sample Size"
            control={control}
            required
            inputType="text"
            inputProps={{
              placeholder: 'Enter sample size',
              className: 'w-full',
            }}
          />
        </div>
      </div>
      <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-6 mt-6">
        <div className="space-y-4">
          <ControlledFormInput
            name="selfShellFabricCode"
            label="Self (Shell) Fabric Code & Name"
            control={control}
            inputType="text"
            inputProps={{
              placeholder: 'Enter fabric code and name',
              className: 'w-full',
            }}
          />
        </div>
      </div>
    </>
  );
}
